import { Controller } from '@hotwired/stimulus'
import TcAdapter from "tcadapter";

export default class extends Controller {
  static values = {
    fileId: String,
    appid: String,
    psign: String,
    id: String,
    url: String,
  }
  connect() {
    const isSupported = TcAdapter.isSupported();

    const self = this
     console.log("video js", isSupported,  "fileid", this.fileIdValue, "appid",this.appidValue, "psing", this.psignValue, this.idValue);
    this.adapter = new TcAdapter(this.element, {
      fileID: self.fileIdValue,
      appID: self.appidValue,
      psign: self.psignValue,
      hlsConfig: {
        maxBufferSize: 1 * 1024 * 1024,
      }
    }, () => {
      console.log('basicInfo', this.adapter.getVideoBasicInfo());
    });

    this.adapter.on(TcAdapter.TcAdapterEvents.HLSREADY, () => {
      const hls = this.adapter.hls;
      console.log(hls, this.adapter.getStreamimgOutputList());
    })

    // 初始化观看时间跟踪变量
    this.currentSessionWatched = 0;
    this.lastSavedTime = 0;
    this.lastWatchedSeconds = 0;
    this.saveInterval = null;
    this.hasSavedOnUnload = false;

    // 添加视频事件监听
    this.setupVideoEventListeners();
  }

  disconnect() {
    console.log("video js disconnect");
    // 只有在beforeunload事件中没有保存过的情况下才保存
    if (!this.hasSavedOnUnload) {
      this.saveWatchRecord();
    }
    clearInterval(this.saveInterval);
    // 移除事件监听器，避免内存泄漏
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

  setupVideoEventListeners() {
        console.log("setupVideoEventListeners", this.adapter, "videoElement");

    if (!this.adapter || !this.adapter.el) return;

    const videoElement = this.adapter.el;
    console.log("setupVideoEventListeners", videoElement, "videoElement");
    
    // 添加页面卸载前的事件监听
    this.beforeUnloadHandler = () => {
      console.log('页面即将关闭，保存观看记录');
      this.updateWatchTime();
      this.saveWatchRecordOnUnload();
    };
    window.addEventListener('beforeunload', this.beforeUnloadHandler);

    // 播放事件
    videoElement.addEventListener('play', () => {
      console.log('视频开始播放');
      // 开始计时保存
      // if (!this.saveInterval) {
      //   this.saveInterval = setInterval(() => {
      //     this.updateWatchTime();
      //     this.saveWatchRecord();
      //   }, 10000); // 每秒更新一次
      // }
    });

    // 暂停事件
    videoElement.addEventListener('pause', () => {
      console.log('视频暂停----');
      this.updateWatchTime();
      // this.saveWatchRecord();
    });

    // 结束事件
    videoElement.addEventListener('ended', () => {
      console.log('视频播放结束----');
      this.updateWatchTime();
      this.saveWatchRecord();
      clearInterval(this.saveInterval);
    });

    // 时间更新事件（用于更精确的时间跟踪）
    videoElement.addEventListener('timeupdate', () => {
      // 只有在视频播放状态时才更新观看时间
      if (!videoElement.paused && !videoElement.ended) {
        this.updateWatchTime();
      }
    });

    // 拖动进度条事件（用户手动跳转）
    videoElement.addEventListener('seeked', () => {
      console.log('用户拖动了进度条');
      // 用户拖动进度条后，更新lastSavedTime但不增加观看时间
      this.lastSavedTime = Math.floor(this.adapter.el.currentTime);
    });
  }

  updateWatchTime() {
    if (!this.adapter || !this.adapter.el) return;

    const videoElement = this.adapter.el;
    // 只有在视频播放状态时才更新观看时间
    if (videoElement.paused || videoElement.ended) return;

    const currentTime = Math.floor(videoElement.currentTime);

    if (currentTime > this.lastSavedTime) {
      const increment = currentTime - this.lastSavedTime;
      this.currentSessionWatched += increment;
      this.lastSavedTime = currentTime;
    }

    this.lastWatchedSeconds = Math.max(this.lastWatchedSeconds, currentTime);
    console.log('当前观看时间更新:',this.lastWatchedSeconds, this.currentSessionWatched, '秒');
  }

  saveWatchRecord() {
    if (this.currentSessionWatched < 5 || !this.idValue) return;

    console.log('保存观看记录:', this.currentSessionWatched, '秒');
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({
        video_id: this.idValue,
        watched_seconds: this.currentSessionWatched
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        console.log('观看记录保存成功:', data);
        this.currentSessionWatched = 0; // Reset after successful save
      } else {
        console.error('观看记录保存失败:', data.error);
      }
    })
    .catch(error => {
      console.error('保存观看记录时发生错误:', error);
    });
  }

  saveWatchRecordOnUnload() {
    if (this.currentSessionWatched < 5 || !this.idValue) return;

    console.log('使用navigator.sendBeacon保存观看记录:', this.currentSessionWatched, '秒');
    
    // 设置标志位，避免disconnect方法中重复保存
    this.hasSavedOnUnload = true;
    
    // 准备FormData以支持sendBeacon发送CSRF令牌
    const formData = new FormData();
    formData.append('video_id', this.idValue);
    formData.append('watched_seconds', this.currentSessionWatched);
    formData.append('authenticity_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
    
    // 使用navigator.sendBeacon发送数据
    const success = navigator.sendBeacon('/video_watch_records', formData);
    console.log('sendBeacon结果:', success ? '成功' : '失败');
  }
}
